export default {
    bem_vindo: {
        titulo: 'Welcome',
        paragrafo1: 'Welcome to VAM (Veus Automation Management), a panel where you can view and control all your automations, whether with your local equipment or with support laboratories.',
        paragrafo2: 'Through this Panel and this platform you will be able to monitor and control all the activities of your VNS\'s and much more, in a simple, easy and intuitive way.',
    },
    novidades: {
        titulo: 'Novidades',
        rnds: {
            titulo: 'RNDS',
            data: '12/20/2020',
            texto: 'Our system is homologated and providing integration to the RNDS, transmitting COVID results.'
        },
        lancamento: {
            titulo: 'Launch',
            data: '04/02/2020',
            texto: 'We have officially launched our platform into production, now you can live with us a revolution in the health area.'
        },
        monitoramento: {
            titulo: 'Monitoring',
            data: '03/25/2020',
            texto: 'Now it is possible to monitor all the Orders and Results of your integrations through the Monitors Menu.'
        },
        dashboard: {
            titulo: 'Dashboard',
            data: '02/01/2020',
            texto: 'Our Dashboard is ready to access, track all your automation data through there.'
        }
    }
}